"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedDuplicableGroupDisplayFieldTypes = exports.FormTemplateFieldTypes = void 0;

/**
 * These are the field type strings for Form Templates
 */
var FormTemplateFieldTypes;
exports.FormTemplateFieldTypes = FormTemplateFieldTypes;

(function (FormTemplateFieldTypes) {
  FormTemplateFieldTypes["BOOLEAN"] = "boolean";
  FormTemplateFieldTypes["MULTI_SELECT"] = "multi_select";
  FormTemplateFieldTypes["SINGLE_SELECT"] = "single_select";
  FormTemplateFieldTypes["PHONE_NUMBER"] = "phone_number";
  FormTemplateFieldTypes["EXPLANATION_AREA"] = "explanation_area";
  FormTemplateFieldTypes["MULTI_SELECT_WITH_FREE_FORM"] = "multi_select_with_free_form";
  FormTemplateFieldTypes["MAP_AREA"] = "map_area";
  FormTemplateFieldTypes["NUMBER"] = "number";
  FormTemplateFieldTypes["MULTI_USER"] = "multi_user";
  FormTemplateFieldTypes["SINGLE_SELECT_WITH_FREE_FORM"] = "single_select_with_free_form";
  FormTemplateFieldTypes["SIGNATURE"] = "signature";
  FormTemplateFieldTypes["EMISSION_OBSERVATION"] = "emission_observation";
  FormTemplateFieldTypes["MULTI_LOCATION"] = "multi_location";
  FormTemplateFieldTypes["SINGLE_LOCATION"] = "single_location";
  FormTemplateFieldTypes["TEXT"] = "text";
  FormTemplateFieldTypes["DOCUMENT_UPLOADER"] = "document_uploader";
  FormTemplateFieldTypes["USER"] = "user";
  FormTemplateFieldTypes["TIME"] = "time";
  FormTemplateFieldTypes["DATE"] = "date";
  FormTemplateFieldTypes["WEATHER"] = "weather";
  FormTemplateFieldTypes["TASKS"] = "tasks";
  FormTemplateFieldTypes["PHOTO_CAROUSEL"] = "photo_carousel";
  FormTemplateFieldTypes["TEXT_AREA"] = "text_area";
})(FormTemplateFieldTypes || (exports.FormTemplateFieldTypes = FormTemplateFieldTypes = {}));

var supportedDuplicableGroupDisplayFieldTypes = [FormTemplateFieldTypes.BOOLEAN, FormTemplateFieldTypes.DATE, FormTemplateFieldTypes.MULTI_SELECT, FormTemplateFieldTypes.MULTI_SELECT_WITH_FREE_FORM, FormTemplateFieldTypes.NUMBER, FormTemplateFieldTypes.PHONE_NUMBER, FormTemplateFieldTypes.SINGLE_LOCATION, FormTemplateFieldTypes.SINGLE_SELECT, FormTemplateFieldTypes.SINGLE_SELECT_WITH_FREE_FORM, FormTemplateFieldTypes.TEXT, FormTemplateFieldTypes.TEXT_AREA, FormTemplateFieldTypes.TIME, FormTemplateFieldTypes.WEATHER];
exports.supportedDuplicableGroupDisplayFieldTypes = supportedDuplicableGroupDisplayFieldTypes;